/** @jsx jsx */
import { jsx } from 'theme-ui'

function SvgComponent(props) {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 16h2V8H7v8zm4 0h2V8h-2v8zm-6 2h10V6H5v12zM7 4h6V2H7v2zm8 0V0H5v4H0v2h3v14h14V6h3V4h-5z"
        sx={{ fill: 'tomato' }}
      />
    </svg>
  )
}

export default SvgComponent
